import egg1 from "./img/yellow.png";
import egg1c1 from "./img/yellow1.png";
import egg1c2 from "./img/yellow2.png";
import egg1c3 from "./img/yellow3.png";
import egg1c4 from "./img/yellow4.png";
import egg1Cracked from "./img/yellowCrac.png";
import egg2 from "./img/blue.png";
import egg2c1 from "./img/blue1.png";
import egg2c2 from "./img/blue2.png";
import egg2c3 from "./img/blue3.png";
import egg2c4 from "./img/blue4.png";
import egg2Cracked from "./img/blueCrac.png";
import egg3 from "./img/red.png";
import egg3c1 from "./img/red1.png";
import egg3c2 from "./img/red2.png";
import egg3c3 from "./img/red3.png";
import egg3c4 from "./img/red4.png";
import egg3Cracked from "./img/redCrac.png";
import egg4 from "./img/orange.png";
import egg4c1 from "./img/orange1.png";
import egg4c2 from "./img/orange2.png";
import egg4c3 from "./img/orange3.png";
import egg4c4 from "./img/orange4.png";
import egg4Cracked from "./img/orangeCrac.png";
import egg5 from "./img/pink.png";
import egg5c1 from "./img/pink1.png";
import egg5c2 from "./img/pink2.png";
import egg5c3 from "./img/pink3.png";
import egg5c4 from "./img/pink4.png";
import egg5Cracked from "./img/pinkCrac.png";
import egg6 from "./img/pruple.png";
import egg6c1 from "./img/pruple1.png";
import egg6c2 from "./img/pruple2.png";
import egg6c3 from "./img/pruple3.png";
import egg6c4 from "./img/pruple4.png";
import egg6Cracked from "./img/prupleCrac.png";
import egg7 from "./img/teg.png";
import egg7c1 from "./img/teg1.png";
import egg7c2 from "./img/teg2.png";
import egg7c3 from "./img/teg3.png";
import egg7c4 from "./img/teg4.png";
import egg7Cracked from "./img/tegCrac.png";



export const easterData = {
    "halloween2025_1": {
        payout: 5,
        egg: {
            img1: egg1,
            img2: egg1c1,
            img3: egg1c2,
            img4: egg1c3,
            img5: egg1c4,
            img6: egg1Cracked,
        },
    },
    "halloween2025_2": {
        payout: 5,
        egg: {
            img1: egg2,
            img2: egg2c1,
            img3: egg2c2,
            img4: egg2c3,
            img5: egg2c4,
            img6: egg2Cracked,
        },
    },
    "halloween2025_3": {
        payout: 5,
        egg: {
            img1: egg3,
            img2: egg3c1,
            img3: egg3c2,
            img4: egg3c3,
            img5: egg3c4,
            img6: egg3Cracked,
        },
    },
    "halloween2025_4": {
        payout: 5,
        egg: {
            img1: egg4,
            img2: egg4c1,
            img3: egg4c2,
            img4: egg4c3,
            img5: egg4c4,
            img6: egg4Cracked,
        },
    },
    "halloween2025_5": {
        payout: 5,
        egg: {
            img1: egg5,
            img2: egg5c1,
            img3: egg5c2,
            img4: egg5c3,
            img5: egg5c4,
            img6: egg5Cracked,
        },
    },
    "halloween2025_6": {
        payout: 5,
        egg: {
            img1: egg6,
            img2: egg6c1,
            img3: egg6c2,
            img4: egg6c3,
            img5: egg6c4,
            img6: egg6Cracked,
        },
    },
    "halloween2025_7": {
        payout: 5,
        egg: {
            img1: egg7,
            img2: egg7c1,
            img3: egg7c2,
            img4: egg7c3,
            img5: egg7c4,
            img6: egg7Cracked,
        },
    },
}

